var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            {
              staticClass: "app-side app-side-left",
              class: _vm.isCollapse ? "app-side-collapsed" : "app-side-expanded"
            },
            [
              _c("div", { staticClass: "app-side-logo" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/logo.png"),
                    width: _vm.isCollapse ? "60" : "60",
                    height: "60"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-menu",
                    {
                      staticClass: "el-menu-vertical-demo",
                      attrs: {
                        "default-active": "1",
                        router: "",
                        collapse: _vm.isCollapse
                      },
                      on: { open: _vm.handleOpen }
                    },
                    [
                      _vm._l(_vm.roleMain, function(item) {
                        return [
                          _c(
                            "el-menu-item",
                            {
                              key: "/main/" + item.jumpPath,
                              attrs: { index: item.jumpPath }
                            },
                            [
                              _c("i", { staticClass: "el-icon-menu" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { attrs: { slot: "title" }, slot: "title" },
                                [_vm._v(_vm._s(item.jurisdictionName))]
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-container",
            [
              _c("el-header", { staticClass: "app-header" }, [
                _c(
                  "div",
                  {
                    staticStyle: { width: "60px", cursor: "pointer" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.toggleSideBar.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isCollapse,
                          expression: "!isCollapse"
                        }
                      ],
                      staticClass: "el-icon-d-arrow-left"
                    }),
                    _vm._v(" "),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isCollapse,
                          expression: "isCollapse"
                        }
                      ],
                      staticClass: "el-icon-d-arrow-right"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "app-header-userinfo" },
                  [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "hover", "hide-on-click": false } },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.username) +
                              "\n                "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c("el-dropdown-item", [_vm._v("我的消息")]),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.updatePassword.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("修改密码")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: { divided: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.logout.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v("退出登录")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "el-main",
                { staticClass: "app-body" },
                [
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { "overflow-y": "auto", height: "800px" }
                      },
                      [_c("router-view")],
                      1
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.editUserForm,
            size: "tiny",
            "modal-append-to-body": false
          },
          on: { close: _vm.closeDialog }
        },
        [
          _c(
            "el-form",
            {
              ref: "editsForm",
              attrs: {
                id: "#editsForm",
                model: _vm.editsForm,
                "label-width": "150px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "原密码", prop: "loginName" } },
                [
                  _c("el-input", {
                    attrs: { "max-length": "10", type: "password" },
                    model: {
                      value: _vm.editsForm.loginName,
                      callback: function($$v) {
                        _vm.$set(_vm.editsForm, "loginName", $$v)
                      },
                      expression: "editsForm.loginName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新密码", prop: "loginPassword" } },
                [
                  _c("el-input", {
                    attrs: { "max-length": "10", type: "password" },
                    model: {
                      value: _vm.editsForm.loginPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.editsForm, "loginPassword", $$v)
                      },
                      expression: "editsForm.loginPassword"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "确认密码", prop: "newloginPassword" } },
                [
                  _c("el-input", {
                    attrs: { "max-length": "10", type: "password" },
                    model: {
                      value: _vm.editsForm.newloginPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.editsForm, "newloginPassword", $$v)
                      },
                      expression: "editsForm.newloginPassword"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.studentEdit()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.editUserForm = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-439d5626", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-439d5626","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components.vue
// module id = null
// module chunks = 